module.exports = __webpack_public_path__ + "img/pink.13e88bc6.png";